module.exports = __webpack_public_path__ + "static/media/Glowing_Container@3x.90cd8400.png";